/**
 * Used to identify the chatbot payment flow in the AI Core API.
 * When this param is present, we redirect user to the success page.
 */
export const API_PARAM_PAYMENT = 'ff-chatbot-payment-finish';

/**
 * Checks if the payment param is present in the URL.
 */
export function hasPaymentParam(): boolean {
  const url = new URL(window.location.href);
  const paramPayment = url.searchParams.get(API_PARAM_PAYMENT);

  return !!paramPayment;
}

/**
 * Removes the payment param from the URL and replaces the state.
 */
export function removePaymentParam(): void {
  const url = new URL(window.location.href);
  url.searchParams.delete(API_PARAM_PAYMENT);

  window.history.replaceState({}, document.title, url.toString());
}

/**
 * Sets the payment param in the URL.
 */
export function getPaymentReturnUrl(): string {
  const url = new URL(window.location.toString());
  url.searchParams.append(API_PARAM_PAYMENT, 'true');

  return url.toString();
}

export function getPortalContainer() {
  // Production uses shadow DOM so we need to get the container from the shadow root
  const shadowRoot = document.querySelector('form-factory-chatbot')?.shadowRoot;

  if (shadowRoot) {
    return shadowRoot.getElementById('form-factory-chatbot-app__container');
  }

  // Development uses the default container
  return document.getElementById('form-factory-chatbot-app__container');
}

/**
 * Return true for localhost and playground domains.
 */
export function isPlaygroundDomain() {
  return (
    window.location.hostname.startsWith('playground.form-factory') ||
    window.location.hostname.startsWith('localhost')
  );
}
